// extracted by mini-css-extract-plugin
module.exports = {"video":"media-youtube_video__5ReaR"};